// import React, { useEffect, useState } from "react";
// import "../assets/transactions/SavingTransactionForm.css";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";

// const SavingAccountTransaction = () => {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);

//   const [formData, setFormData] = useState({
//     amount: "",
//     transactionType: "",
//     paymentMode: "CASH",
//     transactionDate: "",
//     narration: "",
//   });

// //   console.log("sleec",selectedAccount?.id)
//   /* ================= FETCH PROFILE ================= */
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   /* ================= FETCH SAVING ACCOUNTS ================= */
//   useEffect(() => {
//       const fetchAccounts = async () => {
//         try {
//           const res = await axios.get(`${API_URL}/get-all-saving-account`, {
//             params: {
//               superAdminId: profile.superAdminId || 14,
//               branchId: profile.branchId || 8,
//               createdBy: localStorage.getItem("userId"),
//             },
//           });

//           const list = res.data?.accounts || [];
//           setAccounts(list);

//           // Auto-select first account (UX improvement)
//           // if (list.length > 0) {
//           //   setSelectedAccount(list[0]);
//           // }
//         } catch (err) {
//           toast.error(err?.response?.data?.message || "Failed to fetch accounts");
//         }
//       };
//     if (!profile) return;

//     fetchAccounts();
//   }, [profile]);

//   /* ================= HANDLE INPUT ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedAccount) {
//       toast.warn("Please select saving account");
//       return;
//     }

//     if (
//       !formData.amount ||
//       !formData.transactionType ||
//       !formData.transactionDate
//     ) {
//       toast.warn("Please fill all required fields");
//       return;
//     }

//     if (
//       formData.transactionType === "WITHDRAWAL" &&
//       Number(formData.amount) > Number(selectedAccount.currentBalance)
//     ) {
//       toast.warn("Withdrawal amount exceeds available balance");
//       return;
//     }

//     try {
//       const payload = {
//         savingAccountId: selectedAccount.id,
//         amount: Number(formData.amount),
//         transactionType: formData.transactionType,
//         paymentMode: formData.paymentMode,
//         transactionDate: formData.transactionDate,
//         remarks: formData.narration,
//         status:"Paid",
//         employeeId: localStorage.getItem("userId"),
//         createdBy: localStorage.getItem("userId"),
//       };

//       const url =
//         formData.transactionType === "DEPOSIT"
//           ? "/saving-account/bank/deposit"
//           : "/saving-account/bank/withdraw";

//      const res= await axios.post(`${API_URL}${url}`, payload);

//       toast.success(res?.data?.message||"Transaction successful");

//       setFormData({
//         amount: "",
//         transactionType: "",
//         paymentMode: "CASH",
//         transactionDate: "",
//         narration: "",
//       });
//       setSelectedAccount(null);
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Transaction failed");
//     }
//   };

//   useEffect(() => {
//       const fetchKyc = async () => {
//         if (selectedAccount && selectedAccount.customerId) {
//           try{
//              const kycResponse = await axios.get("https://payyug.in/api/list-kyc",
//                 {
//                   params: {
//                     userId: selectedAccount.customerId,
//                     createdId: profile.id,
//                   },
//                 }
//               );
//             setUploadedKyc(kycResponse.data.documents || []);
//           }
//          catch(error){
//           setUploadedKyc([]);
//          }
//       }
//     };
//     fetchKyc();
//   }, [selectedAccount]);

//   return (
//     <div className="saving-account-transaction-container">
//       <h2>Transaction Form</h2>

//       <form
//         className="saving-account-transaction-payment-details"
//         onSubmit={handleSubmit}
//       >
//         <h4>
//           <i className="fa-solid fa-credit-card"></i> Payment Details
//         </h4>

//         <div className="payment-details-container">
//           {/* Row 1 */}
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Saving Account</label>
//                <Select
//                   className="account-select-container"
//                   classNamePrefix="account-select"
//                   placeholder="Search account..."
//                   options={accounts.map((acc) => ({
//                     value: acc.id,
//                     label: `${acc.customerName} | ${acc.accountNumber}`,
//                     account: acc
//                   }))}
//                   value={
//                     selectedAccount
//                       ? {
//                           value: selectedAccount.id,
//                           label: `${selectedAccount.customerName} | ${selectedAccount.accountNumber}`,
//                         }
//                       : null
//                   }
//                   onChange={(selected) => setSelectedAccount(selected?.account)}
//                   isSearchable
//               />
//             </div>

//             <div className="payment-details-inputs">
//               <label>Available Balance</label>
//               <input
//                 type="number"
//                 value={selectedAccount?.currentBalance || ""}
//                 readOnly
//               />
//             </div>
//           </div>

//           {/* Row 2 */}
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Transaction Amount</label>
//               <input
//                 type="number"
//                 name="amount"
//                 value={formData.amount}
//                 onChange={handleChange}
//                 placeholder="Enter amount"
//               />
//             </div>

//             <div className="payment-details-inputs">
//               <label>Transaction Type</label>
//               <select
//                 name="transactionType"
//                 value={formData.transactionType}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Type</option>
//                 <option value="DEPOSIT">DEPOSIT</option>
//                 <option value="WITHDRAWAL">WITHDRAWAL</option>
//               </select>
//             </div>
//           </div>

//           {/* Row 3 */}
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Payment Mode</label>
//               <select
//                 name="paymentMode"
//                 value={formData.paymentMode}
//                 onChange={handleChange}
//               >
//                 <option value="CASH">CASH</option>
//               </select>
//             </div>

//             <div className="payment-details-inputs">
//               <label>Transaction Date</label>
//               <input
//                 type="date"
//                 name="transactionDate"
//                 value={formData.transactionDate}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>

//           {/* Row 4 */}
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Narration</label>
//               <input
//                 type="text"
//                 name="narration"
//                 value={formData.narration}
//                 onChange={handleChange}
//                 placeholder="Optional narration"
//               />
//             </div>
//           </div>
//         </div>

//         <div className="kyc-cards-container">
//           {uploadedKyc.length === 0 ? (
//             <p>No KYC documents found</p>
//           ) : (
//             uploadedKyc.map((doc, index) => {
//               const imageUrl = `https://payyug.in/uploads/${doc.docImage}`;

//               return (
//                 <div className="kyc-card" key={index}>
//                   <img
//                     src={imageUrl}
//                     alt="KYC Document"
//                     className="kyc-image"
//                     onClick={() => window.open(imageUrl, "_blank")}
//                   />
//                   <p className="doctitle">{doc.docName|| "KYC Document"}</p>
//                 </div>
//               );
//             })
//           )}
//         </div>

//         <div className="pay-btn">
//           <button type="submit">Pay</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default SavingAccountTransaction;

import React, { useEffect, useState } from "react";
import "../assets/transactions/SavingTransactionForm.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const SavingAccountTransaction = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [showPreview, setShowPreview] = useState(false); // Modal state

  const [formData, setFormData] = useState({
    amount: "",
    transactionType: "",
    paymentMode: "CASH",
    transactionDate: "",
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-all-saving-account`, {
        params: {
          superAdminId: profile.superAdminId || 14,
          branchId: profile.branchId || 8,
          createdBy: localStorage.getItem("userId"),
        },
      });
      setAccounts(res.data?.accounts || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch accounts");
    }
  };

  useEffect(() => {
    if (profile) fetchAccounts();
  }, [profile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= VALIDATION & PREVIEW ================= */
  const handlePreview = (e) => {
    e.preventDefault();
    if (!selectedAccount) return toast.warn("Please select saving account");
    if (
      !formData.amount ||
      !formData.transactionType ||
      !formData.transactionDate
    ) {
      return toast.warn("Please fill all required fields");
    }
    if (
      formData.transactionType === "WITHDRAWAL" &&
      Number(formData.amount) > Number(selectedAccount.currentBalance)
    ) {
      return toast.warn("Withdrawal amount exceeds available balance");
    }
    setShowPreview(true);
  };

  /* ================= FINAL SUBMIT ================= */
  const handleSubmit = async () => {
    try {
      const payload = {
        savingAccountId: selectedAccount.id,
        amount: Number(formData.amount),
        transactionType: formData.transactionType,
        paymentMode: formData.paymentMode,
        transactionDate: formData.transactionDate,
        remarks: formData.narration,
        status: "Paid",
        employeeId: localStorage.getItem("userId"),
        createdBy: localStorage.getItem("userId"),
      };

      const url =
        formData.transactionType === "DEPOSIT"
          ? "/saving-account/bank/deposit"
          : "/saving-account/bank/withdraw";

      const res = await axios.post(`${API_URL}${url}`, payload);
      toast.success(res?.data?.message || "Transaction successful");

      setFormData({
        amount: "",
        transactionType: "",
        paymentMode: "CASH",
        transactionDate: "",
        narration: "",
      });
      setSelectedAccount(null);
      setShowPreview(false);
      if (profile) fetchAccounts();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Transaction failed");
    }
  };

  useEffect(() => {
    const fetchKyc = async () => {
      if (selectedAccount?.customerId) {
        try {
          const res = await axios.get(`${API_URL}/list-kyc`, {
            params: {
              userId: selectedAccount.customerId,
              createdId: profile.id,
            },
          });
          setUploadedKyc(res.data.documents || []);
        } catch {
          setUploadedKyc([]);
        }
      }
    };
    fetchKyc();
  }, [selectedAccount, profile?.id]);

  return (
    <div className="saving-account-transaction-container">
      <h2>Transaction Portal</h2>

      <form
        className="saving-account-transaction-payment-details"
        onSubmit={handlePreview}
      >
        <h4>
          <i className="fa-solid fa-shield-halved"></i> Payment Details
        </h4>

        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Saving Account</label>
              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                options={accounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNumber}`,
                  account: acc,
                }))}
                value={
                  selectedAccount
                    ? {
                        value: selectedAccount.id,
                        label: `${selectedAccount.customerName} | ${selectedAccount.accountNumber}`,
                      }
                    : null
                }
                onChange={(selected) => setSelectedAccount(selected?.account)}
                isSearchable
              />
            </div>

            <div className="payment-details-inputs">
              <label>Available Balance</label>
              <input
                type="text"
                value={`₹ ${selectedAccount?.currentBalance || "0.00"}`}
                readOnly
              />
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Amount (INR)</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                placeholder="0.00"
              />
            </div>
            <div className="payment-details-inputs">
              <label>Transaction Type</label>
              <select
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="DEPOSIT">DEPOSIT</option>
                <option value="WITHDRAWAL">WITHDRAWAL</option>
              </select>
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
              >
                <option value="CASH">CASH</option>
                <option value="UPI">UPI</option>
                <option value="RTGS">NEFT RTGS</option>
              </select>
            </div>
            <div className="payment-details-inputs">
              <label>Transaction Date</label>
              <input
                type="date"
                name="transactionDate"
                value={formData.transactionDate}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="payment-details-input-groups">
          <div className="payment-details-inputs">
            <label>Narration</label>
            <input
              type="text"
              name="narration"
              value={formData.narration}
              onChange={handleChange}
              placeholder="Optional narration"
            />
          </div>
        </div>

        <div className="kyc-section-title">Verified Documents</div>
        <div className="kyc-cards-container">
          {uploadedKyc.length === 0 ? (
            <p className="no-kyc">No KYC documents found for this account</p>
          ) : (
            uploadedKyc.map((doc, index) => (
              <div className="kyc-card" key={index}>
                <img
                  src={`https://payyug.in/uploads/${doc.docImage}`}
                  alt="KYC"
                  className="kyc-image"
                  onClick={() =>
                    window.open(
                      `https://payyug.in/uploads/${doc.docImage}`,
                      "_blank",
                    )
                  }
                />
                <p className="doctitle">{doc.docName || "Document"}</p>
              </div>
            ))
          )}
        </div>

        <div className="pay-btn">
          <button type="submit">Verify & Process Transaction</button>
        </div>
      </form>

      {/* ================= PREVIEW MODAL ================= */}
      {showPreview && (
        <div className="modal-overlay">
          <div className="transaction-modal">
            <h3>Confirm Transaction</h3>
            <div className="modal-content">
              <div className="modal-row">
                <span>Account:</span>{" "}
                <strong>{selectedAccount.customerName}</strong>
              </div>
              <div className="modal-row">
                <span>A/C Number:</span>{" "}
                <strong>{selectedAccount.accountNumber}</strong>
              </div>
              <div className="modal-row">
                <span>Type:</span>{" "}
                <strong className={formData.transactionType}>
                  {formData.transactionType}
                </strong>
              </div>
              <div className="modal-row amount-row">
                <span>Amount:</span> <strong>₹ {formData.amount}</strong>
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowPreview(false)}
              >
                Edit
              </button>
              <button className="confirm-btn" onClick={handleSubmit}>
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SavingAccountTransaction;
